'use client';

import { Suspense } from 'react';
import LoadingSpinner from './LoadingSpinner';

interface LazyLoadWrapperProps {
  children: React.ReactNode;
}

export default function LazyLoadWrapper({ children }: LazyLoadWrapperProps) {
  return <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>;
}
